import React, { Fragment } from 'react';
import {
    Create,
    Datagrid,
    Edit,
    List,
    NumberInput,
    SimpleForm,
    TextField,
    TextInput,
    Show,
    SimpleShowLayout,
    EditButton,
    ShowButton,
    Button,
    required,
    ArrayInput,
    SimpleFormIterator,
    ArrayField,
    DateField,
    NumberField,
    SelectInput
} from 'react-admin';
import exporterCommon from "../import/exporterCommon";
import DefaultListActions, { Empty } from "./common";
import { DateInput } from "react-admin-date-inputs2";

const PayScaleForm = (props) => (
    <Fragment>
        <TextInput source="name" label="Name" {...props} />
        <TextInput source="description" label="Description" {...props} />
        <TextInput source="grade" label="Grade" {...props} validate={required()} />
        <NumberInput source="step" label="Step" {...props} validate={required()} />
        <NumberInput source="basicSalary" label="Basic Salary" validate={required()} {...props} />
        <SelectInput defaultValue={"ETB"} label='Currency' source="basicCurrency" choices={[
            { id: 'ETB', name: 'ETB' },
            { id: 'USD', name: 'USD' },
            { id: 'EUR', name: 'EUR' },
            { id: 'GBP', name: 'GPB' },
        ]} />
        <ArrayInput source="prevSalaries" label="Previous Salaries">
            <SimpleFormIterator>
                <NumberInput source="basicSalary" label="Basic Salary" validate={required()} />
                <DateInput source="startDate" label="Start Date" validate={required()} />
                <DateInput source="endDate" label="End Date" validate={required()} />
            </SimpleFormIterator>
        </ArrayInput>
    </Fragment>
);

export const PayScaleList = props => (
    <List empty={<Empty />} exporter={exporterCommon(props.resource)} actions={<DefaultListActions />} {...props}>
        <Datagrid rowClick="edit">
            <TextField source="name" />
            <TextField source="description" />
            <TextField source="grade" />
            <TextField source="step" />
            <TextField source="basicSalary" />
            <TextField source="basicCurrency" />
            <ShowButton />
            <EditButton />
        </Datagrid>
    </List>
);

export const PayScaleEdit = props => (
    <Edit {...props}>
        <SimpleForm>
            <PayScaleForm />
        </SimpleForm>
    </Edit>
);

export const PayScaleCreate = props => (
    <Create {...props}>
        <SimpleForm redirect="list">
            <PayScaleForm />
        </SimpleForm>
    </Create>
);

export const PayScaleShow = props => (
    <Show {...props}>
        <SimpleShowLayout>
            <TextField source="name" />
            <TextField source="description" />
            <TextField source="grade" />
            <TextField source="step" />
            <TextField source="basicSalary" />
            <TextField source="basicCurrency" />
            <ArrayField source="prevSalaries" label="Previous Salaries">
                <Datagrid>
                    <NumberField source="basicSalary" label="Basic Salary" />
                    <DateField source="startDate" label="Start Date" />
                    <DateField source="endDate" label="End Date" />
                </Datagrid>
            </ArrayField>
        </SimpleShowLayout>
    </Show>
); 